import axios from 'axios'
import Tip from '../config/Tip'

// let baseUrl = 'https://v2.lixiangshop.com'
// let baseUrl = 'http://101.37.65.243:8091'
// let baseUrl = 'http://test.m.lixiangshop.com'
let baseUrl = 'https://v2.lixiangshop.com'
let instance = {}

instance.postType = function (api, params) {
  let paramData = params
  paramData.scheme = 'https'
  paramData.oem = 'IOS'
  paramData.osversion = '11.0'
  paramData.screenwidth = window.screen.availWidth
  paramData.screenheight = window.screen.availHeight
  paramData.apptype = 'wap'
  paramData.appversion = '1.5.0'
  paramData.nettype = 'unknown'
  paramData.regcode = '250'
  paramData.provcode = '264'
  paramData.partner = 'xigou'
  paramData.token = localStorage.getItem('oldToken') || ''
  return new Promise(function (resolve, reject) {
    axios({
      method: 'POST',
      url: baseUrl + api,
      data: paramData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(function (res) {
      let data = res.data
      if (data === null || data === undefined) {
        // Tip.tip('服务端异常，请稍后重试')
      } else {
        resolve(data)
      }
    }).catch(function (err) {
      // Tip.tip('服务端异常，请稍后重试')
    })
  })
}
instance.getType = function (api, params) {
  let paramData = params
  paramData.scheme = 'https'
  paramData.oem = 'IOS'
  paramData.osversion = '11.0'
  paramData.screenwidth = window.screen.availWidth
  paramData.screenheight = window.screen.availHeight
  paramData.apptype = 'wap'
  paramData.appversion = '1.5.0'
  paramData.nettype = 'unknown'
  paramData.regcode = '250'
  paramData.provcode = '264'
  paramData.partner = 'xigou'
  paramData.token = localStorage.getItem('token') || ''
  return new Promise(function (resolve, reject) {
    axios({
      method: 'get',
      url: baseUrl + api,
      params: paramData
    }).then(function (res) {
      let data = res.data
      resolve(data)
    }).catch(function (err) {
      // Tip.tip('服务端异常，请稍后重试')
    })
  })
}

export default instance



// WEBPACK FOOTER //
// ./src/config/service.js